<template>
    <div class="share-watchlist-modal-bottom">
        <div class="share-watchlist-modal-bottom__total">
            <span class="share-watchlist-modal-bottom__total-number"> {{ getTotalUsersSelected }} </span>
            <span v-html="$t('WatchListModal.share_watchlist_users_selected')"></span>
        </div>
        <span v-if="isDesktopView" class="share-watchlist-modal-bottom__info" v-html="getBottomInfoTextForTab"></span>
        <span v-if="shareWatchlistErrorMessage" class="share-watchlist-modal-bottom__error">
            <span class="icon-notification"></span>
            <span>{{ shareWatchlistErrorMessage }}</span>
        </span>
        <div class="share-watchlist-modal-bottom__buttons">
            <TotemButton
                size="small"
                @click="closeSharedWatchListModal"
                class="share-watchlist-modal-bottom__button"
                :label="$t('General.close')"
            />
            <TotemButton
                size="small"
                v-if="shareWatchListActiveTab === 1"
                :disabled="areAnyUsersSelected(selectedSubordinates)"
                color="primary"
                @click="shareWithSelectedSubordinates"
                class="share-watchlist-modal-bottom__button"
                :label="$t('WatchListModal.share_watchlist_bottom_share-watchlist')"
            />
            <TotemButton
                size="small"
                v-if="shareWatchListActiveTab === 2"
                :disabled="areAnyUsersSelected(selectedMembers)"
                color="primary"
                @click="removeSelectedSubordinates"
                class="share-watchlist-modal-bottom__button"
                :label="$t('WatchListModal.share_watchlist_bottom_remove-subordinates')"
            />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'ShareWatchListModalBottomFunctions',
        computed: {
            ...mapGetters({
                selectedSubordinates: 'Watchlists/getShareWatchListSelectedSubordinates',
                selectedMembers: 'Watchlists/getShareWatchListSelectedMembers',
                shareWatchListActiveTab: 'Watchlists/getShareWatchListTab',
                shareWatchlistErrorMessage: 'Watchlists/getShareWatchlistErrorMessage'
            }),
            getTotalUsersSelected () {
                return this.shareWatchListActiveTab === 1 ? this.selectedSubordinates.length : this.selectedMembers.length
            },
            getBottomInfoTextForTab () {
                return this.shareWatchListActiveTab === 1 ? this.$t('WatchListModal.share_watchlist_bottom_info_not_shared') : this.$t('WatchListModal.share_watchlist_bottom_info_shared')
            },
        },
        methods: {
            areAnyUsersSelected (users) {
                return users.length === 0
            },
            closeSharedWatchListModal () {
                this.$store.dispatch('Watchlists/shareWatchListChangeTab', 1)
                this.$modal.hide('share-watchlist-select-menu')
                this.$store.dispatch('Watchlists/selectTeam', null)
            },
            shareWithSelectedSubordinates () {
                this.$emit('shareWithSelectedSubordinates')
            },
            removeSelectedSubordinates () {
                this.$emit('removeSelectedSubordinates')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .share-watchlist-modal-bottom {

        [class*="mobile"] & {
            padding: 10px 10px;
        }

        .icon-notification {
            margin: 0 5px;
            display:flex;
            align-items: center;
        }

        &__total {
            font-family: PlusJakartaSans-Medium, sans-serif;
            font-size: 1.6rem;
            line-height: 150%;
            display: flex;
            justify-content: flex-end;
            flex-direction: row;
            margin: 10px 0;

            [class*="mobile"] & {
                margin: 5px 10px;
            }
        }
        &__total-number {
            margin: 0 5px 0 0;
        }
        &__buttons {
            display: flex;
            justify-content: flex-end;
            flex-direction: row;
            gap: 20px;

            [class*="mobile"] & {
                padding: 0;
                flex-direction: column;
            }
        }

        &__info {
            display: flex;
            justify-content: flex-end;
            flex-direction: row;
            font-family: PlusJakartaSans-Regular, sans-serif;
            font-size: 1.4rem;
            margin: 12px 0 20px 0;
        }

        &__error {
            display: flex;
            justify-content: flex-end;
            flex-direction: row;
            font-size: 1.6rem;
            margin: 20px 0;
            color: $guardsman_red;
            font-family: 'Quicksand-Bold';
        }
    }
</style>
